function heroPageLoaded() {
  var w_hostname = window.location.hostname;
  w_hostname = w_hostname.toLowerCase();
  var w_subtitle = document.getElementById("w_subtitle");
  var w_title = document.getElementById("w_title");
  var w_href = window.location.href;

  //console.log("href: " + window.location.href);
  // console.log("ref :" + document.referrer);
  // console.log("hostname :" + w_hostname);

  prepareAnnouncementBar();
  
  var doctorFound=false;
  // Iterate through w_registeredDocs
  for (var i = 0; i < w_registeredDocs.length; i++) {
    var doctor = w_registeredDocs[i];
    if (w_hostname.indexOf(doctor.hostname_index_of) > -1) {
      w_subtitle.innerHTML =  doctor.subtitle;
      w_title.innerHTML = doctor.title;

      modifyAnnouncementBar(doctor);
      configureTerminButton(doctor);
      
       if (doctor.logo) {
          var logoImg = document.createElement('img');
          logoImg.src =  "https:"+w_logoMap[doctor.location_id];
          logoImg.alt = 'Logo';
          logoImg.style = 'min-width:10vw;max-width:60vw;';
    
          // Get the div element and set its display to block
          var selectedDocLogoDiv = document.getElementById('w_selectedDocLogo');
          selectedDocLogoDiv.style.display = 'inline-flex';
  
          // Append the image to the div
          selectedDocLogoDiv.appendChild(logoImg);
       }

   
      doctorFound=true;
      break; // Exit the loop once a match is found
    }
  }

  if (!doctorFound) {
    console.log("no url match " + w_hostname);
    //w_subtitle.innerHTML = "Bitte clicken Sie auf Ihren Arzt:";
    //w_title.innerHTML = "Medi-Bestellungen";
    w_selectedDoc.style.display = "block";
  }

  // active scan if its in the url
  if (w_href.indexOf("weanscan")>1) {
    console.log("activate scan");
    openScanModal();
  } else if (w_href.indexOf("waddean")>1) {
    console.log("add ean to cart");
    addEanToCart();
  }
}



document.addEventListener('page:loaded', heroPageLoaded());

document.addEventListener('DOMContentLoaded', function () {
    const selectDoctor = document.getElementById('selectDoctor');
    if (selectDoctor) {
      selectDoctor.addEventListener('change', function () {
        const selectedOption = selectDoctor.options[selectDoctor.selectedIndex];
        const selectedUrl = selectedOption.getAttribute('data-url');
        
        if (selectedUrl) {
          window.location.href = selectedUrl;
        }
      });
    }
  });

var deferredPrompt;
         
window.addEventListener('beforeinstallprompt', function(event) {
  console.log("before install prompt: "+deferredPrompt);
  event.preventDefault();
  deferredPrompt = event;
  if (isMobileDevice() || isSupportedBrowser()) {
    if (document.getElementById("addToHomeScreen") && document.getElementById("addToHomeScreen").style)
      document.getElementById("addToHomeScreen").style.display = "block";
  }
});
document.getElementById("addToHomeScreen2").addEventListener("click", function() {
  console.log("prompt: "+deferredPrompt);
    if(deferredPrompt){
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then(function(choiceResult){
            console.log(choiceResult.outcome);
            if (choiceResult.outcome === 'dismissed') {
                console.log('User cancelled installation');
            } else {
                console.log('User added to home screen');
            }
        });
        deferredPrompt = null;
    }
});         
function isMobileDevice() {
  console.log("br "+navigator.userAgent)
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isSupportedBrowser() {
  // Modify this condition to include specific browsers you want to target
  console.log(" user_agent: "+navigator.userAgent)
  return /Chrome|Firefox|Safari/i.test(navigator.userAgent);
}

function prepareAnnouncementBar() {
  if ( document.getElementById("shopify-section-toolbar"))
    document.getElementById("shopify-section-toolbar").style.display = "none";
}

function configureTerminButton(doctor) {
  var terminButton = document.getElementById('w_termin_button');
  if (!terminButton) return;

  // Check if calendars field exists and is not null/empty
  var calendars = doctor.calendars && doctor.calendars.value ? doctor.calendars.value : doctor.calendars;
  if (doctor.termine && doctor.termine.value) {
    terminButton.href = doctor.termine.value;
    terminButton.style.display = 'inline-block';
  }
  else if (doctor.termine) {
    terminButton.href = doctor.termine;
    terminButton.style.display = 'inline-block';
  }
  // Else keep button hidden
  else {
    terminButton.style.display = 'none';
  }
}

function modifyAnnouncementBar(seldoctor) {
  if (window && window.app) return; // running in app
  if (navigator.userAgent.indexOf('wv') !== -1) return; 
  let ua=navigator.userAgent;
  var inApp=/iPhone|iPad|iPod/.test(ua) && /AppleWebKit/.test(ua) && !/Safari/.test(ua);
  console.log("user_agent and inApp "+ua+" "+inApp)
  if (inApp) return; // its called withing an ios app

  
  var toolbar=document.getElementById("shopify-section-toolbar");
  var storelinks = toolbar.querySelectorAll('a[title="Android Play Store"]');
  
  if (toolbar && seldoctor && seldoctor.playstore && storelinks.length>0) {
    toolbar.style.display="block";

    for (var i = 0; i < storelinks.length; i++) {
      // Assuming 'doc.playstore' contains the new href value
      storelinks[i].href = seldoctor.playstore;
    }    
  }
}
